import * as React from "react";
import { Avatar, Toolbar, Typography } from "@material-ui/core";
import FlagSharpIcon from "@material-ui/icons/FlagSharp";
import { ArtistSummaryEarnings } from "./components/artist-summary-earnings";
import { ArtistSummaryPlan } from "./components/artist-summary-plan";
import { ArtistSummaryReleases } from "./components/artist-summary-releases";
import { ArtistSummaryStreams } from "./components/artist-summary-streams";
import { useParams } from "react-router";
import SimpleArtist from "../../../../../common/types/artist/simple-artist";
import { getArtistsInfo } from "../../sdk/artists";
import { checkPriorityArtist } from "../../sdk/earnings";
import { ArtistSummaryPlatforms } from "./components/artist-summary-platforms";
import { ArtistBlockDialog } from "./components/artist-block-dialog";
import { ArtistVerificationDialog } from "./components/artist-verification-dialog";
import { ArtistSummaryNotes } from "./components/artist-summary-notes";
import { ToolTip } from "../../components/tooltip";
import { ArtistOwnerButton } from "./components/artist-owner-button";
import { ArtistPriorityButton } from "../artist-list/components/artist-priority-button";

export const ArtistDetailPage: React.FC = () => {
  const { artistId } = useParams<{ artistId: string }>();
  const [artist, setArtist] = React.useState<SimpleArtist>();
  const [loading, setLoading] = React.useState(false);
  const [blocked, setBlocked] = React.useState(false);
  const [priorityArtist, setPriorityArtist] = React.useState(false);
  React.useEffect(() => {
    setLoading(true);
    setArtist(undefined);
    getArtistsInfo(artistId)
      .then((artist) => {
        if (artist) {
          if (!(artist?.enabled === undefined || artist?.enabled === true)) {
            setBlocked(true);
          }
          checkPriorityArtist(artist.id).then((resp) => {
            if (resp.isPriorityArtist) {
              setPriorityArtist(true);
            }
          })
        }
        return artist;
      })
      .then(setArtist)
      .finally(() => setLoading(false));
    
  }, [artistId]);
  return (
    <section style={{ margin: "30px" }}>
      <Toolbar variant="dense">
        <Avatar
          src={artist?.avatar}
          style={{ width: "100px", height: "100px", marginRight: "1rem" }}
        />
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <Typography variant="h4" style={{ flexGrow: 1 }}>
            {artist?.name || "loading..."}
          </Typography>
          <Typography variant="h4" style={{ flexGrow: 1 }}>
            {artist?.email || "loading..."}
          </Typography>
        </div>
        <div style={{ display: "flex", marginRight: "20px" }}>
          {artist?.watchlistNote ? (
            <ToolTip helperText={artist.watchlistNote}>
              <FlagSharpIcon color="error" fontSize="large" />
            </ToolTip>
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: "column",
            width: "10%",
          }}
        >
          {artist ? <ArtistOwnerButton artist={artist} /> : null}

          {artist ? (
            <ArtistBlockDialog
              blocked={blocked}
              setBlocked={setBlocked}
              artistId={artist.id}
              artistName={artist.name}
            />
          ) : null}
          {artist ? <ArtistVerificationDialog artist={artist} /> : null}
          {artist ? <ArtistPriorityButton
            artistId={artist.id}
            isPriorityArtist={priorityArtist}
            updateRow={(isPriorityArtist) =>
              setPriorityArtist(isPriorityArtist)
            }
          /> : null}
        </div>
      </Toolbar>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <ArtistSummaryPlan style={{ marginRight: "20px" }} />
        <ArtistSummaryEarnings style={{ marginRight: "20px" }} />
        <ArtistSummaryStreams style={{ marginRight: "20px" }} />
        <ArtistSummaryPlatforms
          loading={loading}
          artist={artist}
          style={{ marginRight: "20px" }}
        />
        <ArtistSummaryNotes />
      </div>

      <ArtistSummaryReleases style={{ marginTop: "20px" }} />
    </section>
  );
};
